import React from "react";
import PropTypes from "prop-types";
import {
	AiOutlineTwitter,
	AiFillFacebook,
	AiFillInstagram,
	AiFillLinkedin,
} from "react-icons/ai";
import "./styles.scss";

function SocialLinks({ classModifier }) {
	return (
		<ul className={`social-links ${classModifier ? classModifier : ""}`}>
			<li>
				<a
					rel="noreferrer"
					className="social-links__link"
					target="_blank"
					href="https://twitter.com/irish_titan"
				>
					<AiOutlineTwitter title={`Twitter`} size={32} />
				</a>
			</li>
			<li>
				<a
					rel="noreferrer"
					className="social-links__link"
					target="_blank"
					href="https://www.instagram.com/irish.titan/"
				>
					<AiFillInstagram title={`Instagram`} size={32} />
				</a>
			</li>
			<li>
				<a
					rel="noreferrer"
					className="social-links__link"
					target="_blank"
					href="https://www.linkedin.com/company/802314/"
				>
					<AiFillLinkedin title={`LinkedIn`} size={32} />
				</a>
			</li>
			<li>
				<a
					rel="noreferrer"
					className="social-links__link"
					target="_blank"
					href="https://www.facebook.com/irishtitanonline/"
				>
					<AiFillFacebook title={`Facebook`} size={32} />
				</a>
			</li>
		</ul>
	);
};

export default SocialLinks;

SocialLinks.propTypes = {
	classModifier: PropTypes.string,
};
